module.exports = __webpack_public_path__ + "img/15-half-md.bc0931f7.jpg";